import React from 'react';
import classNames from 'classnames';
import { Field } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { CATEGORIES } from 'pages/create-activity/constants';

import HelpIcon from '@material-ui/icons/Help';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';

import ConfirmContext from 'contexts/ConfirmContext';

import {
  DropDown,
  CurrencyInputWrapper,
  PopoverWrapper,
  TextIconButton
} from 'components';

import { useStyles } from './styles';

const CategoriesPrices = ({
  fields,
  availableCategories,
  meta: { submitFailed, error },
  tabName,
  tabNameAll
  // dailyPrices
  // selectedTabIndex
}) => {
  const classes = useStyles();
  const confirm = React.useContext(ConfirmContext);
  const [t] = useTranslation();

  const onAddHandler = () => {
    fields.push({
      participant: '',
      USD: '0',
      EUR: '0',
      NOK: '0'
    });
  };

  const onDeleteHandler = (e, index) => {
    e.stopPropagation();

    confirm({
      title: `${t('Are you sure you want to delete')} ${t(tabName)}?`,
      confirmationText: 'Delete',
      cancellationText: 'Back'
    })
      .then(() => {
        fields.remove(index);
      })
      .catch(() => {});
  };

  const onDeleteAllHandler = () => {
    confirm({
      title: `${t('Are you sure you want to delete')} ${t(tabNameAll)}?`,
      confirmationText: 'Delete',
      cancellationText: 'Back'
    })
      .then(() => {
        const firstFieldCopy = fields.get(0);
        fields.removeAll();
        fields.push(firstFieldCopy);
      })
      .catch(() => {});
  };

  const getParticipantList = index => {
    const participant = fields.get(index).participant;
    if (participant) return [participant, ...availableCategories];
    return availableCategories;
  };

  return (
    <div className={classes.wrapper}>
      <div className={classNames(classes.row, classes.buttonsGroup)}>
        {fields.length < CATEGORIES.length && (
          <TextIconButton
            icon={<AddCircleOutlineIcon />}
            text={t('Add new')}
            click={onAddHandler}
          />
        )}
        {fields.length > 1 && (
          <TextIconButton
            icon={<DeleteOutlineIcon />}
            text={t('Delete all')}
            click={onDeleteAllHandler}
          />
        )}
      </div>

      {fields.map((field, index) => (
        <div key={index} className={classes.category}>
          <div className={classNames(classes.row)}>
            <Field
              name={`${field}.participant`}
              className={classes.dropDownField}
              list={getParticipantList(index)}
              label="Category"
              placeholder="Choose category"
              component={DropDown}
            />
            {fields.length > 1 && (
              <IconButton
                className={classes.deleteBtn}
                aria-label="delete"
                onClick={e => onDeleteHandler(e, index)}
              >
                <DeleteOutlineIcon className={classes.deleteIcon} />
              </IconButton>
            )}
          </div>

          <div className={classes.row}>
            <Field
              name={`${field}.NOK`}
              label="NOK"
              isHiddenErrorMsg={true}
              className={classes.currencyField}
              component={CurrencyInputWrapper}
            />
            <Field
              name={`${field}.EUR`}
              label="EUR"
              isHiddenErrorMsg={true}
              className={classes.currencyField}
              component={CurrencyInputWrapper}
            />
            <Field
              name={`${field}.USD`}
              label="USD"
              isHiddenErrorMsg={true}
              className={classes.currencyField}
              component={CurrencyInputWrapper}
            />
            <PopoverWrapper text="Value for at least one currency for each category should be filled in. Currencies marked with zero (or empty) will not be displayed on the widget.">
              <HelpIcon className={classes.helpIcon} />
            </PopoverWrapper>
          </div>
          {submitFailed && error && error[index] && (
            <FormHelperText error>{t(error[index])}</FormHelperText>
          )}
        </div>
      ))}
    </div>
  );
};

export default CategoriesPrices;
